import { render, staticRenderFns } from "./CompaniesDetails.vue?vue&type=template&id=224f9a22&scoped=true&"
import script from "./CompaniesDetails.vue?vue&type=script&lang=js&"
export * from "./CompaniesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesDetails.vue?vue&type=style&index=0&id=224f9a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f9a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardTitle,VSpacer,VTab,VTabItem,VTabs,VTabsItems})
